import { render } from "./Plans.vue?vue&type=template&id=d6b4cc32&scoped=true"
import script from "./Plans.vue?vue&type=script&lang=js"
export * from "./Plans.vue?vue&type=script&lang=js"

import "./Plans.vue?vue&type=style&index=0&id=d6b4cc32&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b4cc32"]])

export default __exports__